export const APP_CONNECT_SUCCESS = 'APP_CONNECT_SUCCESS';
export const LOAD_COUNTRY_LIST_SUCCESS = 'LOAD_COUNTRY_LIST_SUCCESS';

export function appConnectSuccess(payload) {
  return {
    type: APP_CONNECT_SUCCESS,
    payload
  };
}

export function loadCountryListSuccess(payload) {
  return {
    type: LOAD_COUNTRY_LIST_SUCCESS,
    payload
  };
}
